import { render, staticRenderFns } from "./callcenter.vue?vue&type=template&id=03b79b8a&"
import script from "./callcenter.vue?vue&type=script&lang=js&"
export * from "./callcenter.vue?vue&type=script&lang=js&"
import style0 from "./callcenter.vue?vue&type=style&index=0&id=03b79b8a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports